module.exports = __webpack_public_path__ + "static/media/web_service_img_1.2d620cba.jpg";